import { ApolloClient, InMemoryCache } from "@apollo/client/core";
import { provideApolloClient, useQuery } from "@vue/apollo-composable";
import axios from 'axios';
import CONCORD_QUERIES from './concord_queries.js';
import {
  watch
} from 'vue'

let apolloClient = null;

export default {

  setupApollo() {
    if (apolloClient) return true;
    
    if (!window.walkuere_app_data?.concord_url) return false;
    
    const customHeaders = {
      platform: "web",
      App: this.getAppName(),
    };
    apolloClient = new ApolloClient({
      cache: new InMemoryCache(),
      uri: window.walkuere_app_data.concord_url,
      headers: customHeaders,
    });
    provideApolloClient(apolloClient);
    return true;
  },

  getAppName() {
    if (window.walkuere_app_data.isDevmioNlActive) return "devmionl";
    if (window.walkuere_app_data.isDevmioActive) return "devmio";
  return "entwickler";
},

  getAjaxPublicDataUrl: function () {
    return "/wp-json/fidelio/v1/get-public-data";
  },

  async loadPublicData(payload) {
    try {
      const response = await axios.post(this.getAjaxPublicDataUrl(), { 
        page:payload.page,
        'page-size':payload.pagesize, 
        'cat-name': payload.querystring,
        transient_key:payload.transientKey,
        query: payload.query });
      // Handle the response data
      return response.data;  // Return the data if needed
  
    } catch (error) {
      // Handle errors
      console.error('Error submitting data:', error);
      throw error;  // Re-throw the error to propagate it if needed
    }
  },

  getBrandData(brandSlug){
    if (!this.setupApollo()) {
      return {
        result:null,
        loading:false, 
        error:true
      }
    }
    let variablesForQier = {
      slug:brandSlug,
    };
    return useQuery(CONCORD_QUERIES.GET_BRAND_HERO, variablesForQier);

  },

  getPocDataForCategory(slug,id,catId,page,pageSize){
    return new Promise((resolve, reject) => {
      if (!this.setupApollo()) {
        return {
          result:null,
          loading:false, 
          error:true
        }
      }
      let variablesForQier = {
        brandComplexId:id,
        brandComplexSlug:slug,
        PAGE:page,
        PAGE_SIZE:pageSize,
        categoryIds:[catId],
      };
      const {
        result } =  useQuery(CONCORD_QUERIES.GET_POC_DATA_FOR_CATEGORY, variablesForQier);
        watch(result, value => {
          if (value) {
            resolve(value);
          }else{
            reject('Error fetching data');
          }
        });
    });

  },

  getPocDataForBrands(slug,type,page,pageSize){
    return new Promise((resolve, reject) => {
      if (!this.setupApollo()) {
        return {
          result:null,
          loading:false, 
          error:true
        }
      }
      let variablesForQier = {
        type: type,
        brandComplexSlug:slug,
        PAGE:page,
        PAGE_SIZE:pageSize,
      };
      const {
        result } =  useQuery(CONCORD_QUERIES.GET_BRAND_POC_ISSUE, variablesForQier);
        watch(result, value => {
          if (value) {
            resolve(value);
          }else{
            reject('Error fetching data');
          }
        });
    });

  },


  getPocDataForEditors(brandSlug){
    return new Promise((resolve, reject) => {
      if (!this.setupApollo()) {
        return {
          result:null,
          loading:false, 
          error:true
        }
      }
      let variablesForQier = {
        slug:brandSlug,
      };
      const {
        result } =  useQuery(CONCORD_QUERIES.GET_BRAND_HERO, variablesForQier);
        watch(result, value => {
          if (value) {
            resolve(value);
          }else{
            reject('Error fetching data');
          }
        });
    });

  },

  getBrandRelatedInstanceData(brandSlug){
    return new Promise((resolve, reject) => {
      if (!this.setupApollo()) {
        return {
          result:null,
          loading:false, 
          error:true
        }
      }
      let variablesForQier = {
        slug:brandSlug,
      };
      const {
        result } =  useQuery(CONCORD_QUERIES.GET_BRAND_INSTANCES, variablesForQier);
        watch(result, value => {
          if (value) {
            resolve(value);
          }else{
            reject('Error fetching data');
          }
        });
    });

  },


};
